import { render, staticRenderFns } from "./InternalTransferAcc.vue?vue&type=template&id=1cce6384"
import script from "./InternalTransferAcc.vue?vue&type=script&lang=js"
export * from "./InternalTransferAcc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports